import React, { forwardRef } from "react";

import { Button, SvgIconProps, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SvgIconComponent } from "@mui/icons-material";

import colors from "@/assets/scss/_themes-vars.module.scss";

export type BottomBarIconButtonProps = {
  icon: SvgIconComponent | ((
    props: SvgIconProps & { children?: React.ReactNode }
  ) => JSX.Element);
  label: string;
  onClick: () => void;
  selected?: boolean;
};
const BottomBarIconButton = forwardRef<
  HTMLButtonElement,
  BottomBarIconButtonProps
>((props, ref) => {
  const { icon: Icon, label, onClick, selected } = props;
  const theme = useTheme();

  const iconRotation = selected ? "rotate(360deg)" : "rotate(0deg)";
  const getfirstWord = (str: string) => {
    return str.split(" ")[0];
  };
  return (
    <Button
      color="primary"
      onClick={onClick}
      ref={ref}
      sx={[
        {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "unset",
          width: "auto",
          padding: "6px",
          fontSize: '24px',
        },
        !selected && {
          color: colors.gray500,
        },
      ]}
    >
      <Icon
        style={{
          marginBottom: "4px",
          transition: "transform 0.3s",
          transform: iconRotation,
          fontSize: '24px',
        }}
        htmlColor={selected ? theme.palette.primary.main : undefined}
      />
      <Typography
        variant="body2"
        sx={{
          color: selected ? theme.palette.primary.main : undefined,
          fontSize: '14px',
        }}
      >
        {getfirstWord(label)}
      </Typography>
    </Button>
  );
});

export default BottomBarIconButton;
